export default __webpack_public_path__ + "static/media/amico.165499f1.svg";